import { render } from "./Home.vue?vue&type=template&id=36103e37&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=36103e37&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\ATL\\Desktop\\Dev\\p2-osavus\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36103e37"]])

export default __exports__